import React from "react";

interface Props {
  doors: server.dto.Doors
}

const Doors = ({ doors }: Props) => {
  return <table className="s1_table clean">
    <tbody>
      {doors.open && <tr>
        <td>{RESX.Venue.Open}</td>
        <td>{doors.open.localized}</td>
      </tr>}

      {doors.close && <tr>
        <td>{RESX.Venue.Close}</td>
        <td>{doors.close.localized}</td>
      </tr>}
    </tbody>
  </table>;
};

export default Doors;